export default __webpack_public_path__ + "media/zurb/img/lab/playground/foundation-icon-fonts-3/svgs/fi-target-two-3247de60de0f8d660355420c0e670448.svg";